export const re_only_numbers = /^[0-9\b]+$/;

export const  closeOffcanvas = () => {
  const offcanvas = document.querySelector('.offcanvas');
  const backdrop = document.querySelector('.offcanvas-backdrop');
  offcanvas.classList.remove('show');
  backdrop.classList.remove('show');
}